import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addcardtype',
  templateUrl: './addcardtype.component.html',
  styleUrls: ['./addcardtype.component.css']
})
export class AddcardtypeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  cardtypeColl: any = [];
  cardtypeid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  cardtypeform = new FormGroup({
    cardtypeid: new FormControl(0),
    cardtypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Cardtype";


  @Input() cardtypename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.cardtypeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.cardtypeform.reset();
      this.fnInitializeCardtype();

      if (this.cardtypeid > 0) {
        this.fngetCardtype();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.cardtypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeCardtype() {
    this.cardtypeform.setValue({

      cardtypeid: 0,
      cardtypename: '',
      inactive: false,
    })
  }

  //Get 
  fngetCardtype() {

    var data = {
      'cardtypeid': this.cardtypeid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getCardtype(data)
      .subscribe(
        (res) => {
          this.cardtypeColl = res.json().result;
          var editdata = this.cardtypeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.cardtypeform.valid) {
        //Check
        this.saveloading = true

        var data = {
          'cardtypeid': this.cardtypeid,
          'cardtypename': this.cardtypeform.get('cardtypename').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.cardtypeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckCardtype(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.cardtypeform.get('cardtypeid').value > 0) {
                //Update Department
                this.fnSetCardtype(data);
              }
              else {
                //Insert Department
                this.fnInsertCardtype(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false

                this.cardtypeform.controls['cardtypename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertCardtype(data) {

    this.appService.fnInsertCardtype(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The new Card Type has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.cardtypeid);

          this.emitData.emit(this.cardtypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetCardtype(data) {

    this.appService.fnSetCardtype(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The Card Type has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.cardtypeid, data.cardtypename);

          this.emitData.emit(this.cardtypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.cardtypeform.setValue({

      cardtypeid: deptBO.cardtypeid,
      cardtypename: deptBO.cardtypename,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
